import { createRouter, RouterProvider } from '@tanstack/react-router'

import './global.scss'

import AppErrorState from './components/AppErrorState'
import { useGenerationNotifications } from './hooks/useGenerationNotifications'
import { AuthProvider } from './lib/auth/AuthProvider'
import { routeTree } from './routeTree.gen'

// Create a new router instance
const router = createRouter({
  routeTree,
  notFoundMode: 'root',
  defaultErrorComponent: ({ error, reset }) => <AppErrorState error={error} onRetry={reset} />,
  defaultPreload: 'intent',
  scrollRestoration: true
})

const navigateToGeneration = (href: string) => {
  void router.navigate({ href })
}

function AppContent() {
  useGenerationNotifications(navigateToGeneration)
  return <RouterProvider router={router} />
}

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}
